import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux'
import { Collapse } from 'reactstrap';
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Circles } from '../common/loadingComponent';
import { Semaphore } from '../common/semaphors';
import { MomentDate } from '../common/momentComponent';
import { domainActions } from '../../store/domainStore'
import { getHostApi, getHostUrl } from '../../store/apiWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { apiGet, isObjectPathDefined, hasPermission } from '../../store/apiWrapper';
import { marketingListActions, unicornCountry, unicornAttribute, unicornFinStatementOrganizationValues } from '../../store/marketingListStore'
import Message from '../common/message';
import ModalInner from '../layoutItems/modalInner';

import OpenIcon from '../../img/icons/BBiconsRozbalit';
import CheckIcon from '../../img/icons/Check';
import CrossIcon from '../../img/icons/Cross';

class DetailsPopup extends React.Component {
    state = {
        isLoading: false,
        data: {},
        error: null
    };

    render() {
        return (
            <ModalInner close={() => this.props.close()} title={this.getTitle()}>
                {this.state.error && <Message type="error" message={this.props.translate(this.state.error.message)} options={{ renderInnerHtml: true }} />}
                {this.state.isLoading && <Circles />}
                {this.renderRequests()}
            </ModalInner>
        )
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        apiGet(`${getHostApi()}/api/marketing-list/overview/${this.props.data}`, null,
            (r) => this.onDataSuccess(r),
            (r) => r.data && this.onError(r.data.error))

        if (isNullOrUndefined(this.props.domain['fin-statement-values-organizations-types'].requestResult)) {
            this.props.ensureDomainData('fin-statement-values-organizations-types', { marketAttribute: unicornAttribute() });
        }

        if (isNullOrUndefined(this.props.domain['fin-statement-values-organizations-values-sasp'].requestResult)) {
            this.props.ensureDomainData('fin-statement-values-organizations-values-sasp', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
        }

        if (isNullOrUndefined(this.props.domain['fin-statement-values-organizations-values-v'].requestResult)) {
            this.props.ensureDomainData('fin-statement-values-organizations-values-v', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
        }

        if (isNullOrUndefined(this.props.domain['fin-statement-values-organizations-values-vh'].requestResult)) {
            this.props.ensureDomainData('fin-statement-values-organizations-values-vh', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
        }

        if (isNullOrUndefined(this.props.domain['fin-statement-values-organizations-values-vp'].requestResult)) {
            this.props.ensureDomainData('fin-statement-values-organizations-values-vp', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
        }
    }

    getTitle() {
        const reqID = `${this.props.translate("MarketingList.Common.Shortening")}${this.props.data}`;
        return !this.state.isLoading && this.state.data && this.state.data.requestName ? this.state.data.isTemplate
            ? this.state.data.requestName : `${this.state.data.requestName} (${reqID})` : reqID;
    }

    onDataSuccess(r) {
        this.setState({ isLoading: false, data: r.data });
    }

    onError(error) {
        this.setState({ isLoading: false, error: error });
    }

    renderRequests() {
        if (!this.state.isLoading && isObjectPathDefined(this.state, 'data.requestSections')) {
            return (
                <div className="details-popup">
                    <h2 style={{ textAlign: "center", paddingBottom: "1em" }}><Translate id="MarketingList.Criteria" /></h2>
                    {this.state.data.requestSections.rating && this.renderRating("rating", this.state.data.requestSections.rating)}
                    {this.state.data.requestSections.contracts && this.renderExtended("contracts", this.state.data.requestSections.contracts)}
                    {this.state.data.requestSections.procurements && this.renderExtended("procurements", this.state.data.requestSections.procurements)}
                    {this.state.data.requestSections.grants && this.renderExtended("grants", this.state.data.requestSections.grants)}
                    {this.state.data.requestSections.status && this.renderStatus("status", this.state.data.requestSections.status)}
                    {this.state.data.requestSections.activity && this.renderActivity("activity", this.state.data.requestSections.activity)}
                    {this.state.data.requestSections.foreignTrade && this.renderForeignTrade("foreignTrade", this.state.data.requestSections.foreignTrade)}
                    {this.state.data.requestSections.warnings && this.renderWarnings("warnings", this.state.data.requestSections.warnings)}
                    {this.state.data.requestSections.additional && this.renderWarnings("additional", this.state.data.requestSections.additional)}
                    {this.state.data.requestSections.sources && this.renderWarnings("sources", this.state.data.requestSections.sources)}
                    {this.state.data.requestSections.legalForm && this.renderLegal("legalForm", this.state.data.requestSections.legalForm)}
                    {this.state.data.requestSections.registeredCapital && this.renderRegisteredCapital("registeredCapital", this.state.data.requestSections.registeredCapital)}
                    {this.state.data.requestSections.relationship && this.renderRelationship("relationship", this.state.data.requestSections.relationship)}
                    {this.state.data.requestSections.address && this.renderAddress("address", this.state.data.requestSections.address)}
                    {this.state.data.requestSections.premises && this.renderPremises("premises", this.state.data.requestSections.premises)}
                    {this.state.data.requestSections.financial && this.renderFinancial("financial", this.state.data.requestSections.financial)}
                    {this.state.data.requestSections.vehicles && this.renderVehicles("vehicles", this.state.data.requestSections.vehicles)}
                    {this.state.data.requestSections.file && this.renderFile("file", this.state.data.requestSections.file)}
                    {this.state.data.requestSections.portfolio && this.renderPortfolio("portfolio", this.state.data.requestSections.portfolio)}

                    <h2 style={{ textAlign: "center", paddingBottom: "1em", marginTop: "1em" }}><Translate id="MarketingList.Configuration" /></h2>
                    {this.state.data.configSections.common && this.renderCommon("common", this.state.data.configSections.common)}
                    {this.state.data.configSections.warnings && this.renderConfigWarnings("warnings", this.state.data.configSections.warnings)}
                    {this.state.data.configSections.financial && this.renderConfigFinancial("financial", this.state.data.configSections.financial)}
                    {this.state.data.configSections.rating && this.renderCommon("rating", this.state.data.configSections.rating)}
                    {this.state.data.configSections.activities && this.renderCommon("activities", this.state.data.configSections.activities)}
                    {this.state.data.configSections.procurements && this.renderConfigExtended("procurements", this.state.data.configSections.procurements)}
                    {this.state.data.configSections.contracts && this.renderConfigExtended("contracts", this.state.data.configSections.contracts)}
                    {this.state.data.configSections.grants && this.renderConfigExtended("grants", this.state.data.configSections.grants)}
                    {this.state.data.configSections.relations && this.renderConfigRelations("relations", this.state.data.configSections.relations)}
                    {this.state.data.configSections.ess && this.renderConfigEss("ess", this.state.data.configSections.ess)}
                    {this.state.data.configSections.msp && this.renderConfigMsp("msp", this.state.data.configSections.msp)}
                    {this.state.data.configSections.timeSeries && this.renderConfigTimeSeries("timeSeries", this.state.data.configSections.timeSeries)}
                    {this.state.data.configSections.vehicles && this.renderConfigVehicles("vehicles", this.state.data.configSections.vehicles)}
                    {this.state.data.configSections.premises && this.renderConfigPremises("premises", this.state.data.configSections.premises)}
                </div >
            )
        }
        return null;
    }

    renderFile(name, data) {
        const fName = data.data.file;
        const fHasNotFoundSubjects = data.data.hasNotFound;
        const includeEntities = data.data.searchType === "ADD_VALUES";
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.Common.FileName" /></div>
                    <div className="req-data">{fName}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label">
                        {includeEntities && <Translate id="MarketingList.AddSubjectsFromExcel" />}
                        {!includeEntities && <Translate id="MarketingList.RemoveSubjectsFromExcel" />}
                    </div>
                    <div className="req-data">
                        <Translate id="Common.Yes.Lower" />
                    </div>
                </div>
                {fHasNotFoundSubjects === "True" && !isNaN(parseInt(this.props.data)) && <div className="req-body-row">
                    <div className="req-label"><Translate id="MarketingList.File.NotFound.Subjects" /></div>
                    <div className="req-data">
                        <a className="link-functional" href={`${getHostUrl()}/files/marketing-list/not-found/${this.props.data}`} target="_blank" >
                            <Translate id="MarketingList.Results.Button.Download" />
                        </a>
                    </div>
                </div>}
            </DetailRow>
        )
    }

    renderPortfolio(name, data) {
        const includeEntities = data.data.searchType === "ADD_VALUES";
        const portfolioName = data.data.portfolioName;

        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="MarketingList.PortfolioName" /></div>
                    <div className="req-data">{portfolioName}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label">
                        {includeEntities && <Translate id="MarketingList.AddSubjectsFromPortfolio" />}
                        {!includeEntities && <Translate id="MarketingList.RemoveSubjectsFromPortfolio" />}
                    </div>
                    <div className="req-data">
                        <Translate id="Common.Yes.Lower" />
                    </div>
                </div>
            </DetailRow>
        )
    }

    renderRating(name, data) {
        const { cribisIndexMin, cribisIndexMax, semaphores, groupSemaphores } = { ...data.data };
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Report.Ratings.SectionName" /></div>
                    <div className="req-data">{cribisIndexMax} - {cribisIndexMin}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="MarketingList.Rating.Semaphore" />
                    </div>
                    <div className="req-data">
                        {semaphores && semaphores.map((s, i) => <Semaphore key={i} type={s} size="small" />)}
                    </div>
                </div>
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="MarketingList.Rating.GroupSemaphore" />
                    </div>
                    <div className="req-data">
                        {groupSemaphores && groupSemaphores.map((s, i) => <Semaphore key={i} type={s} size="small" />)}
                    </div>
                </div>
            </DetailRow>
        )
    }

    renderExtended(name, data) {
        const { countFrom, countTo, currency, from, to, sumFrom, sumTo, hasItems, direction } = { ...data.data };
        const procurementsDirection = (isNullOrUndefined(direction) || direction == "") ? "" : (direction === 0 ? <Translate id="Common.DoesNotMatter" />
            : (direction === 1 ? <Translate id="MarketingList.Procurements.Direction.Submitter" /> : <Translate id="MarketingList.Procurements.Direction.Supplier" />));

        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Common.Currency" /></div>
                    <div className="req-data">{currency}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Report.Common.Date" /></div>
                    <div className="req-data"><MomentDate value={from} /> - <MomentDate value={to} /></div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.Common.Sum" /></div>
                    <div className="req-data">{sumFrom} - {sumTo}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.Common.Count" /></div>
                    <div className="req-data">{countFrom} - {countTo}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label">{this.props.translate(getLabel(name))}</div>
                    <div className="req-data">{(hasItems === null || hasItems) ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                {(procurementsDirection !== "") &&
                    <div className="req-body-row">
                        <div className="req-label"><Translate id="MarketingList.Procurements.Direction" /></div>
                        <div className="req-data">{procurementsDirection}</div>
                    </div>}
            </DetailRow>
        )
    }

    renderPremises(name, data) {
        const { searchType, street, postalCode, cities, districts, regions } = { ...data.data };
        const hasPremisesAddress = (!isNullOrUndefined(street) && street != '') ||
            (!isNullOrUndefined(cities) && cities.all.length > 0) ||
            (!isNullOrUndefined(postalCode) && postalCode != '') ||
            (!isNullOrUndefined(districts) && districts.all.length > 0) ||
            (!isNullOrUndefined(regions) && regions.all.length > 0);

        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label">{this.props.translate(getLabel(name))}</div>
                    <div className="req-data">{searchType === 1 ? <Translate id="Premises.SearchType.Actual" /> : searchType === 2 ? <Translate id="Premises.SearchType.All" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="MarketingList.Premises.Addr" /></div>
                    <div className="req-data">{hasPremisesAddress ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
            </DetailRow>
        )
    }

    renderVehicles(name, data) {
        const { hasItems, historyTo } = { ...data.data };
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label">{this.props.translate(getLabel(name))}</div>
                    <div className="req-data">{hasItems ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Report.Common.History" /></div>
                    {this.renderVehicleHistoryRow(historyTo)}
                </div>
            </DetailRow>
        )
    }

    renderVehicleHistoryRow(val) {
        return <div className="req-data">{val > 1900
            ? `${this.props.translate("Search.Marketing.Vehicles.NotOlderThan")} ${val}`
            : `${this.props.translate("Search.Marketing.Vehicles.OlderThan")} 2014`}</div>
    }

    renderStatus(name, data) {
        const { registrationFrom, registrationTo, isVatPayer, isActive } = { ...data.data };
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.SubjectStatus.RegistrationDate" /></div>
                    <div className="req-data"><MomentDate value={registrationFrom} /> - <MomentDate value={registrationTo} /></div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.SubjectStatus.VatPayer" /></div>
                    <div className="req-data">{isVatPayer !== null ? isVatPayer ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" /> : ""}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.SubjectStatus.IsActive" /></div>
                    <div className="req-data">{isActive !== null ? isActive ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" /> : ""}</div>
                </div>
            </DetailRow>
        )
    }

    renderActivity(name, data) {
        const { onlyMainNace, minEmployees, maxEmployees, nace, naceSource, employeeRanges, turnovers, turnoverYears, ownerships, institutionalSectors } = { ...data.data };
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.ActivityScope.EmployeesCount" /></div>
                    <div className="req-data">{minEmployees} - {maxEmployees}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.ActivityScope.OnlyMainNace" /></div>
                    <div className="req-data">{onlyMainNace !== null ? onlyMainNace ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                {nace && this.renderMulti("Search.Filter.NaceID", nace.allSelected, nace.all[0])}
                {nace && unicornCountry() === 'sk' && <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.ActivityScope.NaceSource" /></div>
                    <div className="req-data">{this.props.translate(this.getNaceSourceDesc(naceSource))}</div>
                </div>}
                {employeeRanges && this.renderMulti("Search.ActivityScope.SizeCategory", employeeRanges.allSelected, employeeRanges.all[0])}
                {turnovers && this.renderMulti("Search.ActivityScope.Turnover", turnovers.allSelected, turnovers.all[0])}
                {turnoverYears && <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.ActivityScope.TurnoverYears" /></div>
                    <div className="req-data">{this.getTurnoverYearsDesc(turnoverYears)}</div>
                </div>}
                {ownerships && unicornCountry() === 'sk' && this.renderMulti("Search.ActivityScope.OwnershipTypeSk", ownerships.allSelected, ownerships.all[0])}
                {institutionalSectors && this.renderMulti("Search.ActivityScope.InstitutionalSector", institutionalSectors.allSelected, institutionalSectors.all[0])}
            </DetailRow>
        )
    }

    getNaceSourceDesc = (naceSource) => {
        switch (naceSource) {
            case 'Rsk': return 'Search.ActivityScope.NaceResSk';
            case 'Ruz': return 'Search.ActivityScope.NaceRegUz';
            default: return 'Search.ActivityScope.NaceAll';
        }
    }

    getTurnoverYearsDesc = (turnoverSource) => {
        var criteria = "";
        for (var i = 0; i < turnoverSource.all.length; i++) {

            if (turnoverSource.all[i] == "rc") {
                criteria = criteria + " " + this.props.translate('Search.ActivityScope.TurnoverYears.Recent')
            } else {
                criteria = criteria + " " + "20" + turnoverSource.all[i];
            }

            if (i != turnoverSource.all.length - 1) {
                criteria = criteria + ", ";
            }
        }
        return criteria;
    }

    renderForeignTrade(name, data) {
        const ft = (data || {}).data;
        return (
            <DetailRow name={name} hasData={data.hasData}>
                {ft && ft.export && this.renderMulti("Search.ForeignTrade.Export", ft.export.allSelected, ft.export.all[0])}
                {ft && ft.import && this.renderMulti("Search.ForeignTrade.Import", ft.import.allSelected, ft.import.all[0])}
            </DetailRow>
        )
    }

    renderWarnings(name, data) {
        const { positive, negative } = ((data || {}).data || {});
        let positiveLabel = "";
        let negativeLabel = "";
        switch (name) {
            case "warnings":
                positiveLabel = "Search.Marketing.RegisteredWarningInfo";
                negativeLabel = "Search.Marketing.NotRegisteredWarningInfo";
                break;
            case "additional":
                positiveLabel = "Search.Marketing.RegisteredSupplementaryInfo";
                negativeLabel = "Search.Marketing.NotRegisteredSupplementaryInfo";
                break;
            case "sources":
                positiveLabel = "Search.Marketing.RegisteredLiens";
                negativeLabel = "Search.Marketing.NotRegisteredLiens";
                break;
        }
        return (
            <DetailRow name={name} hasData={data.hasData} isParameter={true}>
                {positive && this.renderMulti(positiveLabel, positive.allSelected, positive.all[0])}
                {negative && this.renderMulti(negativeLabel, negative.allSelected, negative.all[0])}
            </DetailRow>
        )
    }

    renderLegal(name, data) {
        return (
            <DetailRow name={name} hasData={data.hasData}>
                {data && data.data && this.renderMulti("Report.CompanyIdentification.LegalForm", data.data.allSelected, data.data.all[0])}
            </DetailRow>
        )
    }

    renderRegisteredCapital(name, data) {
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.Common.RegisteredCapital" /></div>
                    <div className="req-data">{data != null && data.data != null && data.data.checked ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
            </DetailRow>
        )
    }

    renderRelationship(name, data) {
        const { dob, fullname } = ((data || {}).data || {})
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="Search.ByRelation.BirthDateOrPin" />
                    </div>
                    <div className="req-data">
                        {dob}
                    </div>
                </div>
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="Search.ByRelation.Name" />
                    </div>
                    <div className="req-data">
                        {fullname}
                    </div>
                </div>
            </DetailRow>
        )
    }

    renderAddress(name, data) {
        const { regions, districts, cities, street, zip } = ((data || {}).data || {})
        return (
            <DetailRow name={name} hasData={data.hasData}>
                {regions && this.renderMulti("Search.Label.Region", regions.allSelected, regions.all[0])}
                {districts && this.renderMulti("Search.Label.District", districts.allSelected, districts.all[0])}
                {cities && this.renderMulti("Search.Label.City", cities.allSelected, cities.all[0])}
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="Search.Address.Street" />
                    </div>
                    <div className="req-data">
                        {street}
                    </div>
                </div>
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="Search.Address.Zip" />
                    </div>
                    <div className="req-data">
                        {zip}
                    </div>
                </div>
            </DetailRow>
        )
    }

    renderFinancial(name, data) {
        const { year, values, valuesIfrs, valuesIfrsOriginal, ratios, checkLastOnly, organizationsValues } = ((data || {}).data || {})
        let typesValuesDict = [];
        if (!isNullOrUndefined(organizationsValues)) {
            let finValues = organizationsValues.values.map(v => v.value);
            this.props.domain['fin-statement-values-organizations-types'].requestResult.forEach(type => {
                let result = this.props.domain['fin-statement-values-organizations-values-' + type.value];
                if (isNullOrUndefined(result.requestResult)) return;

                let count = result.requestResult.filter(finValue => finValues.includes(finValue.value)).length;
                typesValuesDict.push({ key: type.label, count: count })
            });
        }

        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="Search.Marketing.FinancialStatementAvailability" />
                    </div>
                    <div className="req-data">
                        {year == 1900 ? this.props.translate("Search.Marketing.FinancialStatementAvailability.Any") : year}
                    </div>
                </div>
                {!isNullOrUndefined(checkLastOnly) &&
                    <div className="req-body-row">
                        <div className="req-label">
                            <Translate id="Search.Marketing.FinancialCheckLastOnly" />
                        </div>
                        <div className="req-data">
                            {checkLastOnly ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}
                        </div>
                    </div>}
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id={`Search.Marketing.FinancialStatementData${unicornCountry().toUpperCase()}`} />
                    </div>
                    <div className="req-data">
                        {values && values.values.length.toString()}
                    </div>
                </div>
                {unicornCountry() === 'sk' && <><div className="req-body-row">
                    <div className="req-label">
                        <Translate id={`Search.Marketing.FinancialStatementDataIfrs`} />
                    </div>
                    <div className="req-data">
                        {valuesIfrs && valuesIfrs.values.length.toString()}
                    </div>
                </div>
                    <div className="req-body-row">
                        <div className="req-label">
                            <Translate id={`Search.Marketing.FinancialStatementDataIfrsOriginal`} />
                        </div>
                        <div className="req-data">
                            {valuesIfrsOriginal && valuesIfrsOriginal.values.length.toString()}
                        </div>
                    </div>
                </>}
                {/* Organizations */}
                {/* TODO AAN: Ako zobrazit tie vykazy? */}
                <DetailRow name="finOrganizations" hasData={!isNullOrUndefined(organizationsValues) && organizationsValues.values.length > 0}>
                    {!isNullOrUndefined(typesValuesDict) &&
                        typesValuesDict.map((val) => { return this.renderFinancialOrganizationsRow(val.key, val.count) })}
                </DetailRow>
                {/* Ratios */}
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="Report.FinancialRatios.RatiosSection" />
                    </div>
                    <div className="req-data">
                        {ratios && ratios.values.length.toString()}
                    </div>
                </div>
            </DetailRow>
        )
    }

    renderFinancialOrganizationsRow(label, count) {
        return (<div className="req-body-row">
            <div className="req-label">{label}</div>
            <div className="req-data">{count}</div>
        </div>);
    }

    renderCommon(name, data) {
        const count = data.data.count;

        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="Report.Quick.Common.Count" />
                    </div>
                    <div className="req-data">
                        {count}
                    </div>
                </div>
            </DetailRow>
        )
    }
    renderConfigWarnings(name, data) {
        const { warnings, additional, sources, historical, details } = ((data || {}).data || {});

        return (
            <DetailRow name={name} hasData={data.hasData}>
                {warnings && this.renderMulti('Report.Warnings.SectionName', warnings.allSelected, warnings.all[0])}
                {sources && this.renderMulti('Search.MarketingSection.Sources', sources.allSelected, sources.all[0])}
                {additional && this.renderMulti('Report.Warnings.SupplementaryInfo', additional.allSelected, additional.all[0])}
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="Common.Historical" />
                    </div>
                    <div className="req-data">
                        {historical ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}
                    </div>
                </div>
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="Common.Details" />
                    </div>
                    <div className="req-data">
                        {details ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}
                    </div>
                </div>
            </DetailRow>
        )
    }

    renderConfigFinancial(name, data) {
        const { howMany, yearFrom, ratios, statements, statementsIfrsConsolidated, statementsIfrsIndividual, statementsIfrsOrig, option, statementsOrganizationsRows } = ((data || {}).data || {});
        return (
            <DetailRow name={name} hasData={data.hasData}>
                {option === "newest" ?
                    <div className="req-body-row">
                        <div className="req-label">
                            <Translate id="Search.Marketing.Latest" />
                        </div>
                        <div className="req-data">
                        </div>
                    </div>
                    : option === "newer-than" ?
                        <div className="req-body-row">
                            <div className="req-label">
                                <Translate id="Search.Marketing.NewerThan" />
                            </div>
                            <div className="req-data">
                                {yearFrom}
                            </div>
                        </div>
                        :
                        <div className="req-body-row">
                            <div className="req-label">
                                <Translate id="Search.Marketing.LastXYears" />
                            </div>
                            <div className="req-data">
                                {howMany}
                            </div>
                        </div>
                }
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id={`Search.Marketing.FinancialData${unicornCountry().toUpperCase()}`} />
                    </div>
                    <div className="req-data">
                        {statements}
                    </div>
                </div>
                {unicornCountry() === 'sk' && <>
                    <div className="req-body-row">
                        <div className="req-label">
                            <Translate id="Search.Marketing.FinancialDataIfrsOrig" />
                        </div>
                        <div className="req-data">
                            {statementsIfrsOrig}
                        </div>
                    </div>
                    <div className="req-body-row">
                        <div className="req-label">
                            <Translate id="Search.Marketing.FinancialDataIfrsIndividual" />
                        </div>
                        <div className="req-data">
                            {statementsIfrsIndividual}
                        </div>
                    </div>
                    <div className="req-body-row">
                        <div className="req-label">
                            <Translate id="Search.Marketing.FinancialDataIfrsConsolidated" />
                        </div>
                        <div className="req-data">
                            {statementsIfrsConsolidated}
                        </div>
                    </div>
                    <div className="req-body-row">
                        <div className="req-label">
                            <Translate id="Report.FinancialRatios.Organizations" />
                        </div>
                        <div className="req-data">
                            {statementsOrganizationsRows}
                        </div>
                    </div>
                </>}
                <div className="req-body-row">
                    <div className="req-label">
                        <Translate id="Search.Marketing.FinancialRatios" />
                    </div>
                    <div className="req-data">
                        {ratios}
                    </div>
                </div>
            </DetailRow>
        )
    }

    renderConfigExtended(name, data) {
        const { countFrom, countTo, from, to, sumFrom, sumTo } = ((data || {}).data || {});
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Report.Common.Date" /></div>
                    <div className="req-data">{from} - {to}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.Common.Sum" /></div>
                    <div className="req-data">{sumFrom} - {sumTo}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.Common.Count" /></div>
                    <div className="req-data">{countFrom} - {countTo}</div>
                </div>
            </DetailRow>
        )
    }

    renderConfigRelations(name, data) {
        const { historical, count, allSelected } = ((data || {}).data || {});
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Common.Historical" /></div>
                    <div className="req-data">{historical === "True" ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Search.Common.Count" /></div>
                    <div className="req-data">{allSelected === "True" ? <Translate id="Report.Trades.All" /> : count}</div>
                </div>
            </DetailRow>
        )
    }

    renderConfigTimeSeries(name, data) {
        const { lastX, registeredCapital, turnoverCategory, employeesCategory, employeesCount, mainNace, mainNaceRuz } = ((data || {}).data || {});
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Search.Marketing.LastX" /></div>
                    <div className="req-data">{lastX}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="MarketingList.TimeSeries.TurnoverCategory" /></div>
                    <div className="req-data">{turnoverCategory ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Search.Common.RegisteredCapital" /></div>
                    <div className="req-data">{registeredCapital ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="MarketingList.TimeSeries.EmployeesCategory" /></div>
                    <div className="req-data">{employeesCategory ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="MarketingList.TimeSeries.EmployeesCount" /></div>
                    <div className="req-data">{employeesCount ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="MarketingList.TimeSeries.MainNace" /></div>
                    <div className="req-data">{mainNace ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                {unicornCountry() === 'sk' && <div className="req-body-row">
                    <div className="req-label"><Translate id="MarketingList.TimeSeries.MainNaceRuz" /></div>
                    <div className="req-data">{mainNaceRuz ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>}
            </DetailRow>
        )
    }

    renderConfigPremises(name, data) {
        const { actual, historical } = ((data || {}).data || {});
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Common.Actual" /></div>
                    <div className="req-data">{actual === "True" ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Common.Historical" /></div>
                    <div className="req-data">{historical === "True" ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
            </DetailRow>
        )
    }

    renderConfigVehicles(name, data) {
        const { categories, status, registration, registrationCr, deRegistration, leasing } = ((data || {}).data || {});
        return (
            <DetailRow name={name} hasData={data.hasData}>
                {categories && this.renderMulti('Search.Marketing.Vehicles.Category', categories.allSelected, categories.all[0])}
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Search.Marketing.Vehicles.Status" /></div>
                    <div className="req-data">
                        {status === "0" && <Translate id="Common.DoesNotMatter" />}
                        {status === "new" && <Translate id="Search.Marketing.Vehicles.Status.New" />}
                        {status === "used" && <Translate id="Search.Marketing.Vehicles.Status.Used" />}
                    </div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Search.Marketing.Vehicles.RegistrationDate" /></div>
                    {this.renderVehicleHistoryRow(registration)}
                </div>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Search.Marketing.Vehicles.RegistrationCrDate" /></div>
                    {this.renderVehicleHistoryRow(registrationCr)}
                </div>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Search.Marketing.Vehicles.DeRegistrationDate" /></div>
                    {this.renderVehicleHistoryRow(deRegistration)}
                </div>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Search.Marketing.Vehicles.FinancialLeasing" /></div>
                    <div className="req-data">
                        {leasing === "0" && <Translate id="Common.DoesNotMatter" />}
                        {leasing === "yes" && <Translate id="Common.Yes" />}
                        {leasing === "no" && <Translate id="Common.No" />}
                    </div>
                </div>
            </DetailRow>
        )
    }

    renderConfigEss(name, data) {
        const { type, minShare } = ((data || {}).data || {});
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Search.Marketing.FinalOwners" /></div>
                    <div className="req-data">{type === "1" ? <Translate id="Common.Yes.Lower" /> : '-'}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Search.Marketing.Ess" /></div>
                    <div className="req-data">{type === "2" ? <Translate id="Common.Yes.Lower" /> : '-'}</div>
                </div>
                {!hasPermission(null, 'EconomicGroupSberbankMethodology') && hasPermission(null, 'EconomicGroupEdit') &&
                    <div className="req-body-row">
                        <div className="req-label"> <Translate id="Search.Marketing.Ess.MinimalShare" /></div>
                        <div className="req-data">{minShare}</div>
                    </div>
                }
            </DetailRow>
        )
    }

    renderConfigMsp(name, data) {
        const { total, computedEmployeesCount, computedTurnover, computedAssets, ovm, partnersCount, connectedPartners, connectedPartnersSubjects } = ((data || {}).data || {});
        return (
            <DetailRow name={name} hasData={data.hasData}>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Report.EconomicGroup.SME.Total" /></div>
                    <div className="req-data">{total ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"> <Translate id="Report.EconomicGroup.SME.ComputedEmployeesCount" /></div>
                    <div className="req-data">{computedEmployeesCount ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Report.EconomicGroup.SME.ComputedTurnover" /></div>
                    <div className="req-data">{computedTurnover ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Report.EconomicGroup.SME.ComputedAssets" /></div>
                    <div className="req-data">{computedAssets ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Report.EconomicGroup.SME.Ovm" /></div>
                    <div className="req-data">{ovm ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Report.EconomicGroup.SME.PartnersCount" /></div>
                    <div className="req-data">{partnersCount ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Report.EconomicGroup.SME.ConnectedPartners" /></div>
                    <div className="req-data">{connectedPartners ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
                <div className="req-body-row">
                    <div className="req-label"><Translate id="Report.EconomicGroup.SME.ConnectedPartnersSubjects" /></div>
                    <div className="req-data">{connectedPartnersSubjects ? <Translate id="Common.Yes.Lower" /> : <Translate id="Common.No.Lower" />}</div>
                </div>
            </DetailRow>
        )
    }

    renderMulti(name, all, count) {
        return (
            <div className="req-body-row">
                <div className="req-label"><span>{ReactHtmlParser(this.props.translate(name))}</span> </div>
                {typeof count === 'object' && <div className="req-data">{all ? <Translate id="Report.Trades.All" /> : (count || {}).value}</div>}
                {typeof count !== 'object' && <div className="req-data">{all ? <Translate id="Report.Trades.All" /> : count}</div>}
            </div>
        )
    }
}

class DetailRow extends React.Component {
    state = { expanded: false }

    render() {
        return (
            <div className="req-row">
                <div className="req-header">
                    <div onClick={() => this.setState({ expanded: !this.state.expanded })} style={{ cursor: this.props.hasData ? "pointer" : "not-allowed" }}>
                        {this.props.hasData && <OpenIcon style={{ transform: this.state.expanded ? "none" : "rotate(-90deg)" }} />}
                        <Translate>
                            {({ translate }) => <span>{ReactHtmlParser(translate(getLabel(this.props.name, this.props.isParameter)))}</span>}
                        </Translate>
                    </div>
                    <div>{this.props.hasData ? <CheckIcon /> : <CrossIcon />}</div>
                </div>
                {this.props.hasData && this.props.children && <Collapse className="req-body" isOpen={this.state.expanded}>
                    {this.props.children}
                </Collapse>}
            </div>
        )
    }
}

function getLabel(parent, isParameter) {
    switch (parent) {
        case "ratings":
        case "rating":
            return "Report.Ratings.SectionName";
        case "procurements":
            return "Search.PublicProcurements";
        case "legalForms":
        case "legalForm":
            return "Report.CompanyIdentification.LegalForm";
        case "address":
            return "Search.Common.Address";
        case "premises":
            return "Search.Marketing.Premises";
        case "relationship":
            return "Search.ByRelation.Header";
        case "relations":
            return "Report.Relations.SectionName";
        case "ess":
            return "Search.Marketing.Ess";
        case "contracts":
            return "Report.PublicContracts.SectionName";
        case "foreignTrades":
        case "foreignTrade":
            return "Search.ForeignTrade.HeaderSk";
        case "status":
            return "Search.SubjectStatus.Header";
        case "activities":
            return "Search.Marketing.Activities";
        case "activity":
            return "Search.ActivityScope.Header";
        case "grants":
            return "Report.Grants.SectionName";
        case "financial":
            return "Search.MarketingSection.Financial";
        case "additional":
            return "Report.Warnings.SupplementaryInfo";
        case "warnings":
            return isParameter ? "Report.Warnings.SectionName" : "Search.MarketingList.WarningAndAdditional";
        case "sources":
            return "Search.MarketingSection.Sources";
        case "common":
            return "Search.MarketingList.CommonInfo";
        case "file":
            return "Search.Common.FileName";
        case "timeSeries":
            return "Search.Marketing.Timeseries";
        case "msp":
            return "Report.EconomicGroup.StatusEvaluationSectionName";
        case "vehicles":
            return "Search.Marketing.Vehicles";
        case "registeredCapital":
            return "Search.Common.RegisteredCapital";
        case "portfolio":
            return "MarketingList.PortfolioName";
        case "finOrganizations":
            return "Report.FinancialRatios.Organizations";
        default:
            return "";
    }
}

export default withLocalize(connect(
    state => { return { marketingList: state.marketingList, domain: state.domain } },
    dispatch => bindActionCreators(Object.assign({}, marketingListActions, domainActions), dispatch)
)(DetailsPopup));